import { render, staticRenderFns } from "./Modallogin.vue?vue&type=template&id=3bbb18b1&scoped=true&"
import script from "./Modallogin.vue?vue&type=script&lang=js&"
export * from "./Modallogin.vue?vue&type=script&lang=js&"
import style0 from "./Modallogin.vue?vue&type=style&index=0&id=3bbb18b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbb18b1",
  null
  
)

export default component.exports